import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconAngelSideMenuSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="23.738" height="17.269" viewBox="0 0 23.738 17.269"
             className={classNames(['svg-icon svg-angel', className])}>
            <g transform="translate(-101.221 -171.971)">
                <g transform="translate(111.852 175.931)">
                    <path fill={color} fillRule="evenodd" stroke="rgba(0,0,0,0)" d="M324.819,254.986a.762.762,0,0,0-.762.762v7.72a.762.762,0,0,0,.762.762h2.3a.762.762,0,0,0,.762-.762v-.088a.762.762,0,0,1,1.3-.54l1.168,1.168a.762.762,0,0,0,.54.224h1.627a.762.762,0,0,0,.762-.762v-1.632a.762.762,0,0,0-.223-.54l-1.176-1.176a.762.762,0,0,1,.54-1.3h.1a.762.762,0,0,0,.762-.762v-2.3a.762.762,0,0,0-.762-.762Z" transform="translate(-324.057 -254.986)" />
                </g>
                <path fill={color} d="M112.4,189.239c-.2,0-.393,0-.589,0a4.82,4.82,0,0,1-2.149-.558,5.12,5.12,0,0,1-1.472-1.154,5.787,5.787,0,0,1-.966-1.517,6.329,6.329,0,0,1-.475-1.688c-.035-.258-.047-.264-.185-.338a5.534,5.534,0,0,1-2.849-4.4c-.065-.459-.126-.6-.344-.766a5.553,5.553,0,0,1-1.973-3.247,7.72,7.72,0,0,1-.181-1.628s0-.008,0-.012v-.01a1.915,1.915,0,0,1,1.913-1.936l1.426,0,.75,0c4.115-.008,8.3-.007,12.344-.006h3.4a3.911,3.911,0,0,1,3.906,3.906v9.446a3.914,3.914,0,0,1-3.91,3.91H113.87l-.729,0Zm-9.465-15.318a6.022,6.022,0,0,0,.138,1.263,3.831,3.831,0,0,0,1.357,2.277,2.611,2.611,0,0,1,.986,1.88,3.859,3.859,0,0,0,1.958,3.125,1.954,1.954,0,0,1,1.077,1.619,4.616,4.616,0,0,0,.346,1.23,4.071,4.071,0,0,0,.678,1.069,3.387,3.387,0,0,0,.971.765,3.123,3.123,0,0,0,1.386.37c.43.005.871,0,1.3,0l.738,0h7.179a2.195,2.195,0,0,0,2.192-2.192v-9.446a2.191,2.191,0,0,0-2.189-2.189h-3.4c-4.045,0-8.227,0-12.341.006l-.749,0-1.43,0a.19.19,0,0,0-.138.058.2.2,0,0,0-.057.143s0,.008,0,.012Z" transform="translate(0 0)" />
            </g>
        </svg>

    );
};

IconAngelSideMenuSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconAngelSideMenuSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconAngelSideMenuSVG;
